import axios from "axios";
import React, { useEffect, useState } from "react";
import Approved from "../../../assets/Icon/approved.png";
import PromoFile from "../../SuperStar/PromoVideo/PromoFile";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";
const ApprovedPromoVideo = () => {
  const [loading, setLoading] = useState(true);
  const [event, setEvents] = useState([]);
  const [approved, setApproved] = useState("");
  const [count, setLive] = useState("");

  const ApprovedVideos = () => {
    axios.get(`/api/admin/promoVideoApproved`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.promoVideos);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    ApprovedVideos();
  }, []);

  useEffect(() => {
    axios.get(`/api/admin/promoVideoCount`).then((res) => {
      if (res.status === 200) {
        setApproved(res.data.approveTotal);
        setLive(res.data.liveTotal);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title={"Approved Promo Video"}
        image={Approved}
        count={count}
      />
      {loading === true ? (
        <LoaderPost />
      ) : (
        <PromoFile
          data={event}
          urlLink={`/superstar-admin/promoVideo/details`}
        />
      )}{" "}
    </>
  );
};

export default ApprovedPromoVideo;
